export enum SortOrder {
  asc = 'asc',
  desc = 'desc'
};